<template>
  <div>
    <div
      :class="{
        'hidden': source && source === 'app'
      }"
    >
      <van-sticky>
        <div class="header">
          <div class="flex justifyContentCenter tab mb-10">
            <div
              class="tab-item"
              :class="{ 'active': subsectionValue === item.value }"
              v-for="item in tabList"
              :key="item.value"
              @click="handleTab(item.value)"
            >
              {{ item.title }}
            </div>
          </div>

          <div class="flex alignItemsCenter justifyContentBetween">
            <div class="flex flex-1 alignItemsCenter justifyContentBetween left">
              <div class="flex alignItemsCenter item">
                <div class="label">
                  年级：
                </div>
                <div class="flex-1 value ellipsis">
                  {{ selectedGrade.label }}
                </div>
              </div>

              <div class="flex alignItemsCenter item ellipsis">
                <div class="label">
                  学科：
                </div>
                <div class="flex-1 value ellipsis">
                  {{ selectedSubject.label }}
                </div>
              </div>

              <div class="flex alignItemsCenter item ellipsis">
                <div class="label">
                  版本：
                </div>
                <div class="flex-1 value ellipsis">
                  {{ selectedVersion.label }}
                </div>
              </div>
            </div>

            <div class="flex alignItemsCenter screen-text" @click="drawerBoxOpen">
              筛选
              <van-icon name="arrow-down" />
            </div>
          </div>
        </div>
      </van-sticky>

      <a-spin :spinning="loading">
        <div class="flex flexWrap justifyContentBetween main" v-if="materialList && materialList.length">
          <div class="homework-item" v-for="(item, index) in materialList" :key="index">
            <HomeworkItem
              :value="item"
              @change="handleDetail"
            />
          </div>
        </div>

        <div class="displayFlex flexColumn empty" v-else>
          <img src="@/assets/empty.png" alt="">
          <div>暂无数据</div>
        </div>
      </a-spin>
    </div>

    <!-- 筛选 -->
    <van-popup
      class="drawer-box"
      position="bottom"
      closeable
      round
      v-model="drawerBoxVisible"
      safe-area-inset-bottom
      @close="drawerBoxClose"
    >
      <div class="option-box">
        <p v-if="subsectionValue !== 'HIGH_SCHOOL'">年级：</p>
        <div class="select-box" v-if="subsectionValue !== 'HIGH_SCHOOL'">
          <div
            class="s-each"
            v-for="(_grades, _index) in filteredConditions?.grades"
            :key="_grades.value"
            :class="{'active': selectedGrade.index === _index}"
          >
            <span @click="handleSelected('selectedGrade', _index)">{{ _grades.label }}</span>
          </div>
        </div>
        <p>科目：</p>
        <div class="select-box">
          <div
            class="s-each"
            v-for="(_subjects, _index) in filteredConditions?.subjects"
            :key="_subjects.value"
            :class="{'active': selectedSubject.index === _index}"
          >
            <span @click="handleSelected('selectedSubject', _index)">{{ _subjects.label }}</span>
          </div>
        </div>
        <p>版本：</p>
        <div class="select-box">
          <div
            class="s-each"
            v-for="(_versions, _index) in versionOptions"
            :key="_versions"
            :class="{'active': selectedVersion.index === _index}"
          >
            <span @click="handleSelected('selectedVersion', _index)">{{ _versions }}</span>
          </div>
        </div>
      </div>
      <a-button type="primary" shape="round" @click="confirmSelected">确认</a-button>
    </van-popup>

    <!-- 答案 -->
    <template v-if="isShowAnswer">
      <ui-answer @change="toReturn" :value="answerValue" />
    </template>
  </div>
</template>

<script>
import HomeworkItem from './homework-item.vue'
import UiAnswer from "./ui-answer.vue";
import { getMaterialList, getMaterialCondition } from "@/api/material.js";
import { getSubsectionName, getGradeName, getSubjectName, debounce } from "@/utils/filter.js";

export default {
  components: {
    HomeworkItem,
    UiAnswer,
  },
  computed: {
    // 当从手机端跳转过来时自动打开详情页且隐藏返回按钮
    source () {
      return this.$route.query?.source
    },
    // 学科版本
    versionOptions() {
      const source = this.filteredConditions?.subjectVersion || {}
      const index = this.selectedSubject.index || 0
      const subject = index === 0 ? null : this.filteredConditions?.subjects[index]?.value || null
      if (subject) return [
        "全部",
        ...(source[subject] || []),
      ]

      const versionSet = new Set()
      Object.keys(source).forEach(key => {
        const m = source[key] || []
        m.forEach(item => {
          versionSet.add(item)
        })
      })
      return [
        "全部",
        ...Array.from(versionSet),
      ]
    },
  },
  data() {
    return {
      tabList: [
        {
          title: '小学',
          value: 'PRIMARY_SCHOOL'
        },
        {
          title: '初中',
          value: 'JUNIOR_HIGH_SCHOOL'
        },
        {
          title: '高中',
          value: 'HIGH_SCHOOL'
        }
      ],
      subsectionValue: 'PRIMARY_SCHOOL',
      // materialName: null,
      answerValue: null,
      materialId: null,

      loading: false,
      isShowAnswer: false,
      materialList: [],
      subsectionList: [],
      filteredConditions: null,
      drawerBoxVisible: false,
      selectedGrade: { value: null, label: '全部', index: 0 },
      selectedSubject: { value: null, label: '全部', index: 0 },
      selectedVersion: { label: '全部', index: 0 }
    };
  },
  created() {
    this.getConditions()
  },
  methods: {
    // 获取教辅筛选条件详情
    getConditions() {
      this.subsectionList = []
      getMaterialCondition().then((res) => {
        if (res.code === 0) {
          res?.data.forEach(item => {
            this.subsectionList.push({
              label: getSubsectionName(item.subsection),
              value: item.subsection,
              grades: item.conditionInfo?.grades.map(_grades => {
                return {
                  label: getGradeName(_grades),
                  value: _grades
                }
              }) || [],
              subjects: item.conditionInfo?.subjects.map(_subjects => {
                return {
                  label: getSubjectName(_subjects),
                  value: _subjects
                }
              }) || [],
              subjectVersion: item.conditionInfo?.subjectVersion || {},
            })
          })
          this.addAllSelection()
          // 有则用地址栏的，没有则默认第一个
          const querySubsection = this.$route.query?.subsection
          if (querySubsection) {
            this.filteredConditions = this.subsectionList.find(item => item.value === querySubsection) || this.subsectionList[0]
            this.subsectionValue = querySubsection
          } else {
            this.filteredConditions = this.subsectionList[0]
          }
          this.handleSelected('selectedVersion', 0)
          this.getMaterialList()
        } else {
          this.$message.error(res.msg)
        }
      }).catch((err) => {
        console.log(err)
        this.$message.error("服务器异常，加载数据失败")
      })
    },
    handleTab (e) {
      if (this.subsectionValue === e) return
      this.subsectionValue = e
      this.filteredConditions = this.subsectionList.find(item => item.value === e)
      this.init()
      this.getMaterialList()
      console.log(this.subsectionList)
    },
    // 选择学段 - 筛选出条件数据
    handleSelectedSubsection(_sub) {
      if (this.filteredConditions?.value === _sub.value) return
      this.filteredConditions = _sub
      this.subsectionValue = _sub.value
      this.init()
      this.getMaterialList()
    },
    // 打开筛选框
    drawerBoxOpen() {
      this.drawerBoxVisible = true
      const { grades, subjects } = this.filteredConditions
      const g_object = this.selectedGrade
      const s_object = this.selectedSubject
      const v_object = this.selectedVersion

      this.selectedGrade.index = grades.findIndex(_item => _item.value === g_object.value)
      this.selectedSubject.index = subjects.findIndex(_item => _item.value === s_object.value)
      this.selectedVersion.index = this.versionOptions.findIndex(_item => _item === v_object.label)
    },
    // 关闭筛选框
    drawerBoxClose() {
      this.drawerBoxVisible = false
    },
    // 教辅筛选条件
    handleSelected(keyName, indexNumber) {
      this[keyName].index = indexNumber
      if (keyName === 'selectedSubject') {
        this.handleSelected('selectedVersion', 0)
      }
      this.$forceUpdate()
    },
    // 确定筛选条件
    confirmSelected() {
      const { grades, subjects } = this.filteredConditions,
            index_G = this.selectedGrade.index,
            index_S = this.selectedSubject.index,
            index_V = this.selectedVersion.index
      
      if (grades) this.selectedGrade = { ...grades[index_G], index: index_G }
      if (subjects) this.selectedSubject = { ...subjects[index_S], index: index_S }
      if (this.versionOptions) this.selectedVersion = { label: this.versionOptions[index_V], index: index_V }
      this.drawerBoxClose()
      this.getMaterialList()
    },
    // 初始化
    init() {
      this.selectedGrade = { value: null, label: '全部', index: 0 }
      this.selectedSubject = { value: null, label: '全部', index: 0 }
      this.selectedVersion = { label: '全部', index: 0 }
      this.answerValue = null
      this.materialId = null
    },
    // 选择教辅
    handMaterial(item) {
      this.answerValue = item
      this.materialId = item.id
    },
    handleDetail (e) {
      this.answerValue = e
      this.isShowAnswer = true
    },
    viewAnswer() {
      if (!this.answerValue) this.$message.warning("请先选择需要查看的教辅")
      if (!this.answerValue?.answerUrl) {
        this.$message.warning("当前教辅暂无可查看答案");
      } else {
        this.isShowAnswer = true
      }
    },
    // 获取教辅列表
    getMaterialList() {
      this.loading = true
      const grade = this.selectedGrade.value,
            subject = this.selectedSubject.value,
            version = this.selectedVersion.label === '全部' ? null : this.selectedVersion.label,
            subsection = this.filteredConditions.value
      this.materialList = []
      getMaterialList({ grade, subject, version, subsection }).then((res) => {
        if (res.code === 0) {
          this.materialList = res.data || []
          const { source, id } = this.$route.query // 当从手机端跳转过来时会传递这两个参数 自动打开详情页且隐藏返回按钮
          if (source && source === 'app') {
            this.answerValue = this.materialList.find(item => item.id == id)
            this.isShowAnswer = true
          }
        } else {
          this.$message.error(res.msg)
        }
      }).catch((err) => {
        console.log(err)
        this.$message.error("服务器异常，加载数据失败")
      }).finally(() => {
        this.loading = false;
      })
    },
    // 筛选添加全部选项
    addAllSelection() {
      this.subsectionList.forEach(info => {
        let { grades, subjects, versions } = info
        grades.unshift({ label: "全部", value: null })
        subjects.unshift({ label: "全部", value: null })
        // versions.unshift("全部")
      })
    },
    toReturn() {
      this.isShowAnswer = false
    },
    // 教辅名称搜索
    // getMaterialName: debounce(function () {
    //   this.init()
    //   this.getMaterialList()
    // }, 800)
  },
};
</script>

<style lang="less" scoped>
.header{
  padding: 10px;
  background-color: #fff;
  .left{
    width: calc(100% - 100px);
    .item{
      width: 33%;
      .value{
        font-weight: bold;
      }
    }
  }
  .screen-text{
    color: #09C0D7;
  }
}

.tab{
  .tab-item{
    padding: 5px 30px;
    font-size: 13px;
    color: #333;
    &:nth-child(1){
      border: 1px solid #F4F4F6;
      border-right: none;
      border-radius: 6px 0 0 6px;
    }
    &:nth-child(2){
      border: 1px solid #F4F4F6;
    }
    &:nth-last-child(1){
      border: 1px solid #F4F4F6;
      border-left: none;
      border-radius: 0 6px 6px 0;
    }
  }
  .active{
    background-color: #09C0D7;
    color: #fff;
  }
}

.main{
  padding: 10px;
}

.homework-item{
  width: calc(100% / 2 - 5px);
}

.empty{
  height: 60vh;
  img{
    width: 230px;
    height: 150px;
    margin-bottom: 10px;
  }
  div{
    color: #AAAAAA;
  }
}

.drawer-box {
  padding: 20px;
  & > p {
    font-weight: bold;
    margin-bottom: 4px;
  }
  .option-box {
    max-height: 70vh;
    overflow: auto;
  }
  .select-box {
    display: flex;
    flex-wrap: wrap;
    font-size: 12px;
    margin-bottom: 10px;
    .s-each {
      margin: 0 10px 10px 0;
      border: 1px solid #D7D7D7;
      padding: 0 10px;
      min-width: 70px;
      height: 30px;
      text-align: center;
      line-height: 30px;
      border-radius: 4px;
    }
    .active {
      border-color: #09C0D7;
      background: #CEF2F7;
      color: #09C0D7;
    }
  }
  .ant-btn-primary {
    margin-top: 40px;
    margin-left: calc((100% - 320px) / 2);
    width: 320px;
    height: 36px;
    line-height: 36px;
    border-radius: 6px;
    background-color: #09C0D7;
    border-color: #09C0D7;
  }
}

.hidden{
  display: none;
}

/deep/ .ant-drawer-content {
  border-top-left-radius: 20px;
  border-top-right-radius: 20px;
}

/deep/ .ant-drawer-content-wrapper {
  max-height: 96vh !important;
  overflow: auto !important;
}
/deep/ .ant-drawer-content-wrapper {
  height: 500px !important;
  @media screen and (max-height: 600px){
    height: 460px !important;
  }
}
</style>